<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_SelectTheApprovalPosition')"
    :before-close="cancel"
    width="1160px"
    append-to-body
  >
    <div v-show="false" style="display: flex; margin: 10px">
      <span style="align-self:center; margin-right: 5px">{{ $t('CargoMsg.Cargo_Query') }}: </span>
      <el-input v-model="searchValue" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" />
    </div>
    <div class="grid">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="officeDeptTree.gridOptions"
        :column-defs="officeDeptTree.columnDefs"
        :row-data="filterData"
        style="width:100%;min-height: 400px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <template slot="footer">
      <div style="display: flex;text-align: left;">
        <span class="blue">{{ $t('CargoMsg.Cargo_CurrentSelection') }}:</span>
        <div style="flex: 1;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
          {{ displayName }}
        </div>
      </div>
      <div>
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="onReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
export default {
  name: 'ChooseRoleDialog',
  components: { CargoAgGrid },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Array,
      default: () => []
    },
    eventName: {
      type: String,
      default: () => ''
    },
    filterKeys: {
      type: Array,
      default: () => ['englishName', 'chineseName']
    },
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      selectedRows: null,
      displayName: '',
      gridApi: null,
      loading: null,
      parentUuid: null,
      officeDeptTree: {
        columnDefs: [{
          headerName: 'Path',
          field: 'path',
          width: 300,
          hide: true
        }],
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.onGridRowSelected(event)
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            flex: 1,
            tooltipValueGetter: (params) => {
              return ''
            },
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            },
            valueFormatter: (params) => {
              if (params.data.type === 1) {
                return '[' + params.data.code + ']' + params.data.chineseName
              }
              return params.data.chineseName
            }
          },
          onSelectionChanged: (event) => {
            this.selectedRows = event.api.getSelectedRows()
            this.displayName = this.displayNameLabel()
          }
        }
      }
    }
  },
  computed: {
    filterData() {
      const { searchValue, rowData } = this
      if (!searchValue.trim()) {
        return rowData
      } else {
        const filterKeys = this.filterKeys
        return rowData.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1) return true
          }
        })
      }
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.value && this.value.length > 0) {
        const map = {}
        for (const item of this.value) {
          map[item] = true
        }
        for (const user of this.rowData) {
          if (map[user.entityId]) {
            user.checked = true
          }
        }
        this.$nextTick(() => {
          this.officeDeptTree.gridOptions.api.forEachLeafNode((node) => {
            if (node.data['checked']) {
              node.setSelected(true)
              delete node.data.checked
            }
          })
          this.displayName = this.displayNameLabel()
        })
      }
    },
    onSave() {
      const selectRows = this.officeDeptTree.gridOptions.api.getSelectedRows()
      const entityIds = selectRows && selectRows.length > 0 ? selectRows.map(item => { return item.entityId }) : []
      this.$emit('change', entityIds)
      this.cancel()
    },
    onReset() {
      this.searchValue = ''
      this.officeDeptTree.gridOptions.api.forEachLeafNode((node) => {
        node.setSelected(false)
      })
      this.displayName = ''
      this.officeDeptTree.gridOptions.api.clearFocusedCell()
    },
    cancel() {
      this.$emit('close')
    },
    displayNameLabel() {
      if (!this.officeDeptTree.gridOptions.api) {
        return ''
      }
      const selectRows = this.officeDeptTree.gridOptions.api.getSelectedRows()
      if (!selectRows || selectRows.length === 0) {
        return ''
      }
      const nameList = []
      for (const selectRow of selectRows) {
        if (selectRow.type === 3) {
          nameList.push(selectRow.chineseName)
        }
      }
      return nameList.join(',')
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      if (!event.node.selected) {
        // 取消选择时，同步取消子集
        const data = event.data
        if (data.type === 3) { // 子集不用管
          this.parentUuid = data.parentUuid
          return
        }
        if (this.parentUuid === data.uuid) {
          this.parentUuid = null
          return
        }
        const uuid = data.uuid
        this.parentUuid = data.parentUuid
        const childrenKeys = []
        // 遍历所有选中的数据
        const selectRows = this.officeDeptTree.gridOptions.api.getSelectedRows()
        this.getAllChildren(uuid, selectRows, childrenKeys)
        if (childrenKeys.length === 0) {
          return
        }
        this.officeDeptTree.gridOptions.api.forEachLeafNode((node) => {
          if (childrenKeys.indexOf(node.data.uuid) > -1) {
            node.setSelected(false)
          }
        })
      }
      this.$nextTick(async() => {
      })
    },
    getAllChildren(parentUuid, rows, childrenKeys) {
      for (const row of rows) {
        if (row.parentUuid === parentUuid) {
          childrenKeys.push(row.uuid)
          // 递归查找
          this.getAllChildren(row.uuid, rows, childrenKeys)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
